



































































import { computed, defineComponent, getCurrentInstance, reactive, watch, ref, nextTick } from '@vue/composition-api';
import { ChevronLeftIcon } from 'tdesign-icons-vue';
import InviteSetting from '@/renderer/views/desktop/FileManagement/CollaborationSpace/components/InviteSetting.vue';
import SpaceConfig from '@/renderer/views/desktop/ManageConsole/UserManagement/components/spaceConfig.vue';
import InviteQrcode from '@/renderer/components/Qrcode/components/InviteQrcode.vue';
import UserConfigBar from '@/renderer/views/desktop/ManageConsole/UserManagement/components/configBar.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import { SMH } from '@/renderer/scripts/smh';
import { formatSize } from '@/renderer/scripts/utils/tools/index';
import tips from '@/renderer/scripts/utils/tips';
import { getDownloadPath, downloadFileContent } from '@/renderer/scripts/utils/download/downloadHelper';
import { IS_BROWSER } from '@/common/constant/platform';
import inviteMembersHandler, { GenerateCodeStatus } from '../compositions/inviteMemberHandler';

const QRCode = require('qrcode');
interface Props {
  show: boolean;
  group: SMH.ColleborationSpaceInfoData;
}
export default defineComponent({
  name: 'InviteMembers',
  components: {
    InviteSetting,
    UserConfigBar,
    InviteQrcode,
    SpaceConfig,
    ChevronLeftIcon,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: true,
    },
  },
  filters: {
    buttonTheme(val: GenerateCodeStatus, isLable: boolean) {
      if (val === GenerateCodeStatus.IS_START) {
        return isLable ? i18n_t('停止分享') : 'danger';
      }
      return isLable ? i18n_t('恢复') : 'success';
    },
  },
  setup(props: Props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const defaultRoleId = computed(() => vm.$store.getters.defaultRoleId);
    const showDialog = reactive({
      addMembers: false,
      inviteSetting: false,
    });
    const { loadingUrlInfo, inviteUrlInfo, spaceSizeInfo, methods: inviteMemberMethods } = inviteMembersHandler();
    const sizeInfo = computed(() => formatSize(spaceSizeInfo.personalSpaceQuotaSize, true));
    const codeStatus = computed(() => inviteUrlInfo.codeStatus);
    const spaceEditing = ref(false); // 正在设置空间

    const methods = {
      initDialog() {
        spaceEditing.value = false;
      },
      renderRoleId(id: number) {
        const roles = vm.$store.getters.roles as Array<{
          id: number;
          name: string;
        }>;
        return roles.find(role => role.id === id)?.name || i18n_t('观察者');
      },
      toggleAddDialog(val: boolean) {
        showDialog.addMembers = val;
      },
      toggleSettingDialog(val: boolean) {
        showDialog.inviteSetting = val;
      },
      changeUrlStatus() {
        const type = codeStatus.value === GenerateCodeStatus.IS_START ? 'stop' : 'recovery';
        inviteMemberMethods.updateInviteCodeInfo(type);
      },
      changeInviteSetting(key: string, value: boolean | number) {
        const params: Record<string, any> = {};
        params[key] = value;
        inviteMemberMethods.updateInviteCodeInfo(undefined, params);
      },
      // 保存空间设置
      async saveSpaceConfig(spaceConfig: { allowPersonalSpace: boolean; personalSpaceQuotaSize: string }) {
        Object.assign(spaceSizeInfo, spaceConfig);
        if (codeStatus.value === 'NOT_GENERATED') {
          spaceEditing.value = false;
          tips.success(i18n_t('空间设置暂存成功'));
          return;
        }
        await inviteMemberMethods.updateInviteCodeInfo(undefined, spaceConfig);
        spaceEditing.value = false;
      },
      // 保存二维码到本地
      async downloadQrcode() {
        const canvas = document.getElementById('invitation-qrcode') as any;
        const imgContent = canvas.toDataURL(); // 图片base64
        // pc端获得下载路径 TODO 从选路径到本地下载可以抽离成公共下载
        if (!IS_BROWSER) {
          const downloadTarget = await getDownloadPath();
          if (!downloadTarget) return;
          const base64Data = imgContent.replace(/^data:image\/png;base64,/, '');
          const binaryData = new Buffer(base64Data, 'base64');
          downloadFileContent({
            downloadTarget,
            fileName: i18n_t('邀请企业成员二维码.png'),
            fileContent: binaryData,
          });
        } else {
          const a: HTMLAnchorElement = document.createElement('a');
          a.href = imgContent;
          a.download = i18n_t('邀请企业成员二维码.png');
          a.click();
        }
      },
    };
    watch(innerShow, val => {
      if (val) {
        inviteMemberMethods.initData();
        methods.initDialog();
      }
    });
    return {
      sizeInfo,
      innerShow,
      showDialog,
      defaultRoleId,
      ...methods,
      loadingUrlInfo,
      codeStatus,
      inviteUrlInfo,
      spaceEditing,
      spaceSizeInfo,
      inviteMemberMethods,
    };
  },
});
